import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";

export default function SimpleSlider({ images, allLink, rotationAngle }) {

    const [CarouselItem, setCarouselItem] = useState([]);
    useEffect(() => {       
        setCarouselItem(() => images.map((img, index) => (
            <div key={index} className="imgtinyDiv" >
                <a href={allLink[index]} target="_blank">
                    <img
                        style={{ border: '2px solid #000', opacity: 1,
                        transform: `rotate(${rotationAngle[index] ? rotationAngle[index] : 0}deg)` }}
                        className={`tns-lazy-img`}
                        data-src={img}
                        alt={`ad ${index}`}
                        src={img}
                    />
                </a>
            </div>
        )))

    }, [images, allLink])


    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        // fade: true
    };
    return (
        <Slider {...settings}>
            {CarouselItem}
        </Slider>
    );
}
